export const gutHubComDomain = 'github.com'
export const matchGitHosts = new Set([gutHubComDomain])
export const branchNameDefault = 'main'
export const defaultBranches = new Set([branchNameDefault, 'master'])
export const repositoryBranchSpecification = '+:refs/heads/*'
